<template>
  <v-layout  row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <h3 class="headline mb-0">{{ active ? 'Activar' : 'Desactivar' }} Ingreso de Agremiados a la Página</h3>
        </v-card-title>
        <v-card-text>
            <v-switch color="primary" v-model="active" :label="active ? 'Inactivo' : 'Activo'" @change="cambioIngreso"></v-switch>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-flex>

    <v-flex xs12>
        <v-card>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout row wrap>
                        <h3 class="headline mb-0">Descarga de documentos por mes</h3>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-layout row wrap>
                    <v-flex xs11 sm5>
                        <v-dialog
                            ref="dialog"
                            v-model="modal"
                            :return-value.sync="date"
                            persistent
                            lazy
                            full-width
                            width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="date"
                                    label="Mes y Año"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker locale="es-ES" color="primary" v-model="date" type="month" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="modal = false">Cerrar</v-btn>
                            <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs12 pt-2 pb-2>
                        <v-btn :loading="loading" color="primary darken-1" @click="downloadFederacion">Archivo Federacion</v-btn>
                    </v-flex>
                    <v-flex xs12 pt-2 pb-2>
                        <v-btn :loading="loading" :disabled="loading" color="primary darken-1" class="white--text" @click="downloadListaActuaciones">Listar Facturas</v-btn>
                    </v-flex>
                    <v-flex xs12 pt-2 pb-2>
                        <v-btn :loading="loading" color="primary darken-1" @click="downloadAnalistas">Conciliaciones por Usuario</v-btn>
                    </v-flex>
                </v-layout>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-flex>

        <v-dialog
            v-model="loading"
            hide-overlay
            persistent
            width="300"
        >
            <v-card
                color="primary"
                dark
            >
                <v-card-text>
                Porfavor Espere...
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
    name: 'configuracion-inactive-unionize',

    data () {
        return {
            date: '',
            menu: false,
            modal: false,
            active: false,
            loading: false
        }
    },

    mounted() {
        this.statusIngreso()
    },

    methods: {
        
        async cambioIngreso(){
            this.loading = true
            axios.post(`/api/configuracion/change-inactive-unionize`, { active: this.active })
                .then(res => {
                    this.active = res.data.active
                })
                .finally(() => this.loading = false);
        },

        async statusIngreso(){
            this.loading = true
            axios.get(`/api/configuracion/status-inactive-unionize`)
                .then(res => {
                   this.active = res.data.active
                })
                .finally(() => this.loading = false);
        },

        async downloadAnalistas() {
            if(this.date != ''){
                this.loading = true
                await axios({
                    url: `/api/configuracion/download-analistas-excel/${this.date}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                .then(response => {
                    this.date = ''
                    const blob = new Blob([response.data], {type: response.data.type});
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = 'analistas.xlsx';
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error, intente mas tarde'
                    })
                })
                .finally(() => this.loading = false);
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'Seleccione un mes y año'
                })
            }
        },

        async downloadFederacion() {
            if(this.date != ''){
                this.loading = true
                await axios({
                    url: `/api/configuracion/download-federacion-excel/${this.date}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                .then(response => {
                    this.date = ''
                    const blob = new Blob([response.data], {type: response.data.type});
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = 'federacion.xlsx';
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error, intente mas tarde'
                    })
                })
                .finally(() => this.loading = false);
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'Seleccione un mes y año'
                })
            }
        },

        async downloadListaActuaciones() {
            if(this.date != ''){
                this.loading = true
                await axios({
                    url: `/api/configuracion/download-invoices-excel/${this.date}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                .then(response => {
                    this.date = ''
                    const blob = new Blob([response.data], {type: response.data.type});
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = 'facturas.xlsx';
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error, intente mas tarde'
                    })
                })
                .finally(() => this.loading = false);
             }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'Seleccione un mes y año'
                })
            }
        }

    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/InactiveUnionize.vue